import { API_ERROR_CODES, type ApiError } from "src/interfaces/ApiError";
import NotAuthorized from "src/pages/NotAuthorized";

interface Props {
  error?: ApiError;
}

const ApiErrorView = ({ error }: Props) => {
  if (!error) return null;

  switch (error.code) {
    case API_ERROR_CODES.FORBIDDEN:
      return <NotAuthorized message={error.message} />;
    default:
      return null;
  }
};

export default ApiErrorView;
